import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			component: () => import('./views/Login.vue')
		},
		{
			path: '/redirect',
			component: () => import('./views/Redirect.vue')
		},
		{
			path: '/esqueci-senha',
			component: () => import('./views/EsqueciSenha.vue')
		},
		{
			path: '/assine',
			component: () => import('./views/Assine.vue')
		},
		{
			path: '/assine/broker/:broker',
			props: true,
			component: () => import('./views/Assine.vue')
		},
		{
			path: '/assine/broker/:broker/:pointsale',
			props: true,
			component: () => import('./views/Assine.vue')
		},
		{
			path: '/home',
			component: () => import('./views/Home.vue')
		},
		{
			path: '/pagamento',
			component: () => import('./views/Pagamento.vue')
		},
		{
			path: '/pagamento/carne/:idSubscription',
			props: true,
			component: () => import('./views/PagamentoCarne.vue')
		},
		{
			path: '/assinatura',
			component: () => import('./views/Assinatura.vue')
		},
		{
			path: '/assinatura/concluir',
			component: () => import('./views/AssinaturaConclusao.vue')
		},
		{
			path: '/assinatura/concluir/broker/:broker',
			props: true,
			component: () => import('./views/AssinaturaConclusao.vue')
		},
		{
			path: '/assinatura/concluir/broker/:broker/:pointsale',
			props: true,
			component: () => import('./views/AssinaturaConclusao.vue')
		},
		{
			path: '/validate-card',
			component: () => import('./views/ValidateCard.vue')
		},
		{
			path: '/editar-perfil',
			component: () => import('./views/EditarPerfil.vue')
		},
		{
			path: '/validar-contrato',
			component: () => import('./views/Contrato.vue')
		},
		{
			path: '/cancelar-assinatura',
			component: () => import('./views/CancelarAssinatura.vue')
		},
		{
			path: '/selecionar-assinatura',
			component: () => import('./views/SelecionarAssinatura.vue')
		},
		{
			path: '*',
			redirect: '/home'
		}
	]
})


router.beforeResolve((to, from, next) => {
	//console.log(to.path)
	if (to.path == '/' || to.path == '/validar-contrato' || to.path == '/assine' || to.path.indexOf('/assine/broker/') != -1 || to.path == '/esqueci-senha' || to.path == '/validate-card' || to.path == '/redirect') {
		next()
	} else {
		axios.get(process.env.VUE_APP_API_URL + '/user/data',
			{ headers: { 'token': localStorage.getItem("token") } }
		).then((response) => {
			localStorage.setItem("name", response.data.object.name)
			localStorage.setItem("profile", response.data.object.profile)
			localStorage.setItem("subscription", response.data.object.idSubscription);

			// verifica se precisa validar o contrato (timestamp == null)

			axios.get(process.env.VUE_APP_API_URL +
				'/subscription/contract/accepted/' + response.data.object.idSubscription,
				{ headers: { 'token': localStorage.getItem("token") } })
				.then((response) => {
					if (!response.data.object) {
						location.href = '/validar-contrato';
					} else {
						next()
					}
				}).catch(() => {
					next()
				})
		}).catch(() => {
			next('/')
		})
	}
})

export default router
